import request from '@/utils/request'
import store from '@/store'

function getPromotionCode() {
  return store.state.common?.channelPromoteCode || ''
}

/*
 分页查询返回素材合作达人
 */
export function getVideoAuthor(data) {
  if (!data) {
    data = {}
  }
  if (!data.promote_code) {
    data.promote_code = getPromotionCode()
  }
  return request('v1/author/findPublicPage', {
    method: 'GET',
    params: {
      ...data
    }
  })
}

// 新增合作申请补充信息
export function addOne(data) {
  return request('v1/additional/addAdditional', {
    method: 'POST',
    data
  })
}

/*
  查询当前用户下所有的合作申请
 */
export function findByUserId(data, isCommonCheck = true) {
  return request(
    'v1/audit/findByUserId',
    {
      method: 'GET',
      params: {
        ...data
      }
    },
    { commonCheck: isCommonCheck }
  )
}

// 根据Id返回对应的合作申请
export function getOneById(data) {
  return request('v1/audit/getOneById', {
    method: 'GET',
    params: {
      ...data
    }
  })
}

// 根据Id返回对应的合作申请
export function getOneByAuditId(data) {
  return request('v1/additional/getOneByAuditId', {
    method: 'GET',
    params: {
      ...data
    }
  })
}
// 根据Id返回对应的合作申请-H5
export function getOneByH5(data) {
  return request('v1/audit/getOneByH5', {
    method: 'GET',
    params: {
      ...data
    }
  })
}

// 根据素材达人id返回旗下的所有商品
export function findPageByAuthorId(data, signal) {
  return request('v1/cooperationProduct/findPageByAuthorId', {
    method: 'GET',
    params: {
      ...data
    },
    signal
  })
}

/*
  申请新的合作
 */
export function applyCooperate(data) {
  return request('v1/audit/addOne', {
    method: 'POST',
    data
  })
}

// 选择想合作的明星达人
export function findPublicPage(params) {
  if (!params) {
    params = {}
  }
  if (!params.promote_code) {
    params.promote_code = getPromotionCode()
  }
  return request('v1/author/findPublicPage', {
    method: 'GET',
    params
  })
}

// 素材达人公告列表
export function findNoticeByAuthorUniqueId(data) {
  return request('v1/notice/findByAuthorUniqueId', {
    method: 'GET',
    params: {
      ...data
    }
  })
}

// 当前用户下的达人查询
export function authorList(data) {
  return request('v1/audit/authorList', {
    method: 'GET',
    params: {
      ...data
    }
  })
}

// 尝试获取达人联系人
export function getContact(data) {
  return request('v1/contact/getContact', {
    method: 'GET',
    params: {
      ...data
    }
  })
}

// 尝试获取达人联系人
export function addOneByPromote(data) {
  return request('v1/audit/addOneByPromote', {
    method: 'POST',
    data
  })
}

// 公众号-抖音验证码发送
export function weChatSendSms(data) {
  return request('v1/audit-wechat/sendCode', {
    method: 'POST',
    data
  })
}

// 达人申请绑定
export function institutionApplyBind(data) {
  return request('v1/audit-wechat/institutionApplyBind', {
    method: 'POST',
    data
  })
}

// 判断当前达人是否进行了抖音授权
export function checkInstitution(data) {
  return request('v1/audit-wechat/checkInstitution', {
    method: 'POST',
    data
  })
}

// 判断达人是否在抖音进行了结算授权
export function checkBindPid(data) {
  return request('v1/audit-wechat/checkBindPid', {
    method: 'POST',
    data
  })
}

//  通过加密的audit_id获取用户信息
export function getDouyinInfo(params) {
  return request('v1/audit-wechat/getUserInfo', {
    method: 'GET',
    params
  })
}

//  根据电话号码获取公众号用户信息
export function getUserInfoByTelephone(params) {
  return request('v1/audit-wechat/getUserInfoByTelephone', {
    method: 'GET',
    params
  })
}
//  获取二维码以及用户ID等信息
export function getQrCode(params) {
  return request('v1/audit-wechat/getQrCode', {
    method: 'GET',
    params
  })
}

//  新的引导页合作达人接口
export function getPublicPage(params) {
  if (!params) {
    params = {}
  }
  if (!params.promote_code) {
    params.promote_code = getPromotionCode()
  }
  return request('v2/author/findPublicPage', {
    method: 'GET',
    params
  })
}

//  优秀案例展示
export function findCasePage(params, isCommonCheck = true) {
  return request(
    'v1/case/findCasePage',
    {
      method: 'GET',
      params
    },
    { commonCheck: isCommonCheck }
  )
}

//  判断id是否合法接口
export function judgeAudit(data) {
  return request('v1/audit/judgeAudit', {
    method: 'POST',
    data
  })
}

//  h5页面添加合作申请
export function addOneByH5(data) {
  return request('v1/audit/addOneByH5', {
    method: 'POST',
    data
  })
}

//  h5页面添加合作申请-推广
export function addOneByH5Promote(data) {
  return request('v1/audit/addOneByH5Promote', {
    method: 'POST',
    data
  })
}

//  h5页面编辑合作申请
export function editOneByH5(data) {
  return request('v1/audit/editOneByH5', {
    method: 'POST',
    data
  })
}
//  签名协议图片上传接口
export function postSignImg(data) {
  return request('v1/audit-wechat/postSignImg', {
    method: 'POST',
    data
  })
}
// 获取签约协议签名
export function getSignImg(params) {
  return request('v1/audit/getSignImg', {
    method: 'GET',
    params
  })
}

// KOC达人GmvTop榜单
export function getAuditGmvTop(params) {
  return request('v1/author/audit/gmv/top', {
    method: 'GET',
    params
  })
}
// KOL商品GmvTop榜单
export function getProductGmvTop(params) {
  return request('v1/author/product/gmv/top', {
    method: 'GET',
    params
  })
}
// 获取加群二维码
export function getKolWxGroupQrCode(params) {
  return request('v1/author/getQrCode', {
    method: 'GET',
    params
  })
}
// 切片必做任务确认
export function taskAffirm(params) {
  return request('v1/learning/slice/task/affirm', {
    method: 'GET',
    params
  })
}
// 学习中心列表
export function learningMaterialList(params) {
  return request('v1/learning/material/list', {
    method: 'GET',
    params
  })
}
// 判断用户有无添加群聊
export function checkJoinQr(params) {
  return request('v1/author/checkJoinQr', {
    method: 'GET',
    params
  })
}
// 常见问题列表
export function problemList(params) {
  return request('v1/learning/comProblem/list', {
    method: 'GET',
    params
  })
}
// 最新直播
export function getLiveList(params) {
  return request(
    'v1/clip/room/list',
    {
      method: 'GET',
      params
    },
    {
      serviceType: 3
    }
  )
}
//  h5页面添加合作申请
export function v2AddOneByH5(data) {
  if (!data) {
    data = {}
  }
  if (!data.promote_code) {
    data.promote_code = getPromotionCode()
  }
  return request('v2/audit/addOneByH5', {
    method: 'POST',
    data
  })
}
//  h5页面添加合作申请发送验证码短信
export function auditSendMsg(params) {
  return request('v1/audit/sendMsg', {
    method: 'GET',
    params
  })
}
//  用户微信及密码设置状态
export function userBindStatus(params) {
  return request('v1/user/bind/status', {
    method: 'GET',
    params
  })
}
//  检查KOL是否开启蝉剪权限
export function screenCapPower(params) {
  return request('v1/author/screenCap/power', {
    method: 'GET',
    params
  })
}
//  获取渠道商素材达人客服二维码
export function getChannelQrCode(params) {
  return request('v1/author/getChannelQrCode', {
    method: 'GET',
    params
  })
}
// 判断是否为蝉选授权新用户
export function isNewUser(params) {
  return request('v1/audit/check/new', {
    method: 'GET',
    params
  })
}
// 邀请链接判断是否指定渠道商
export function checkAppointXhannel(params, commonCheck = true) {
  if (!params) {
    params = {}
  }
  if (!params.promote_code) {
    params.promote_code = getPromotionCode()
  }
  return request(
    'v1/audit/check/appoint/channel',
    {
      method: 'GET',
      params
    },
    {
      commonCheck
    }
  )
}
// 合作进度列表开放数据取消预约申请
export function reservationApply(data) {
  return request('v1/audit/cancel/reservationApply', {
    method: 'POST',
    data
  })
}
// 根据素材达人id返回旗下的所有商品
export function findProductByAuthorId(params) {
  return request('v1/cooperationProduct/findPageByAuthorId', {
    method: 'GET',
    params
  })
}
// 根据素材达人id返回旗下的所有商品
export function findProductByAuthorIdV3(params) {
  return request('v3/cooperationProduct/findPageByAuthorId', {
    method: 'GET',
    params
  })
}
// 根据素材达人id返回旗下的所有商品
export function findProductByAuthorIdV4(params) {
  return request('v4/cooperationProduct/findPageByAuthorId', {
    method: 'GET',
    params
  })
}
// 根据素材达人id返回旗下的所有商品
export function findPublicPageProduct(params) {
  if (!params) {
    params = {}
  }
  if (!params.promote_code) {
    params.promote_code = getPromotionCode()
  }
  return request('v1/author/findPublicPageProduct', {
    method: 'GET',
    params
  })
}
// 获取达人广场所有可查询字段
export function authorShowFindColumn(params) {
  return request('v1/author/showFindColumn', {
    method: 'GET',
    params
  })
}
// 工作台商品获取蝉剪的跳转链接
export function getCJMaterialLink(params) {
  return request('v1/cooperationProduct/getCJMaterialLink', {
    method: 'GET',
    params
  })
}
// 切片必做的情况列表
export function getMustDoneTask(params) {
  return request('v1/mustDoneTask/list', {
    method: 'GET',
    params
  })
}
// 切片必做,完成点击
export function doneMustDo(data) {
  return request('v1/mustDoneTask/taskDone', {
    method: 'POST',
    data
  })
}
// 切片必做,完成点击
export function taskAllDone(data) {
  return request('v1/mustDoneTask/taskAllDone', {
    method: 'POST',
    data
  })
}
//权益详情
export function getSku(params) {
  return request('v1/clikKolLive/skuV2', {
    method: 'GET',
    params
  })
}
//返回用户的公告列表和风控信息列表
export function getMessage(params) {
  return request('v1/message/list', {
    method: 'GET',
    params
  })
}
// 已读所有公告
export function doneForCooperationAutoId(data) {
  return request('v1/message/doneForCooperationAutoId', {
    method: 'POST',
    data
  })
}

// 获取讲解时间
export function findExplanationTime(params) {
  return request('v1/cooperationProduct/findExplanationTime', {
    method: 'GET',
    params
  })
}
// 获取讲解时间
export function auditFirstQr(params) {
  return request('v1/audit/firstQr', {
    method: 'GET',
    params
  })
}
export function firstQrConfirm(data) {
  return request('v1/audit/firstQrConfirm', {
    method: 'POST',
    data
  })
}
export function unbindAudit(data) {
  return request('v1/audit/unbind', {
    method: 'POST',
    data
  })
}
// 获取讲解时间
export function trainingInfo(params) {
  return request('v1/training/info', {
    method: 'GET',
    params
  })
}

// 推荐达人列表
export function getRecommendAuthors() {
  return request('v1/author/recommendList', {
    method: 'GET'
  })
}

// 商品补库存反馈
export function feedbackLowStock(params) {
  return request('v1/cooperationProduct/feedbackLowStock', {
    method: 'GET',
    params
  })
}

// 商品SKU详情（带实时库存）
export function productSkuWithRealtimeStock(params) {
  return request('v1/product/detail/skuWithRealtimeStock', {
    method: 'GET',
    params
  })
}

// 工作台橱窗违规商品列表
export function getViolationProductPage(params) {
  return request('v1/message/illegalProducts', {
    method: 'GET',
    params
  })
}

// 清理工作台橱窗违规商品
export function clearViolationProducts(data) {
  return request('v1/store/delete', {
    method: 'POST',
    data
  })
}

// 获取渠道商品牌信息
export function getChannelInfo(params) {
  return request('v1/cooperation/channel/info', {
    method: 'GET',
    params
  })
}

// 绑定渠道码
export function bindChannel(data) {
  return request('v1/cooperation/channel/bind', {
    method: 'POST',
    data
  })
}
